// ─── ChoixPuces — rangée de puces sélectionnables (mono-choix) — Core ──
// Remplace les rangées de « puces »/« chips » répétées dans les écrans.
//   <ChoixPuces options={[{id,label}]} value={x} onChange={setX} />
//   pleine : chips en flex égal (barre segmentée) ; sinon chips compactes.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function ChoixPuces({ options = [], value, onChange, pleine = false }) {
  const UI = useUI();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <View style={s.row}>
      {options.map(o => {
        const on = value === o.id;
        return (
          <TouchableOpacity key={String(o.id)} onPress={() => onChange?.(o.id)}
            style={[pleine ? s.chipPlein : s.chip, on && s.chipOn, pleine && { flex: 1 }]}>
            <Text style={[s.txt, on && s.txtOn]} numberOfLines={1}>{o.label}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  row: { flexDirection: 'row', flexWrap: 'wrap', gap: 8 },
  chip: { paddingHorizontal: 13, paddingVertical: 8, borderRadius: 999, backgroundColor: UI.champ, borderWidth: 0.5, borderColor: UI.champBord },
  chipPlein: { paddingVertical: 9, borderRadius: 10, borderWidth: 1, borderColor: UI.champBord, backgroundColor: UI.champ, alignItems: 'center' },
  chipOn: { backgroundColor: UI.accentTint, borderColor: UI.accent },
  txt: { fontSize: 12.5, fontWeight: '700', color: UI.ink },
  txtOn: { color: UI.accent, fontWeight: '800' },
});
